import React, {Component} from 'react';
import {Col, Row, TabContent, TabPane} from "reactstrap";
import * as _ from 'lodash';
import {connect} from "react-redux";
import home from "../../../util/clipstore/user/home"
import tip_util from "../../../util/tip/util"
import api from "../../../util/clipstore/user/api";
import library_api from "../../../util/clipstore/broadcaster/library";
import library from "../../../util/clipstore/broadcaster/library";
import * as actions from "../../../actions";
import "./index.css"
import {PremiumContentModal} from "../../../components/modal/clipstore/user/premiumContentModal";
import pricing from "../../../util/clipstore/user/pricing";
import LoadingBar from 'react-top-loading-bar'
import {getData, LOGIN} from "../../../util/storage";
import {isEmpty, vuepayAlert} from "../../../util/utility";
import {getMoneyBloxCurrentWalletBalance, getMoneyBloxWalletUserSessionDetails} from "../../../assets/libs/MoneyBlox";
import BroadcasterProfileHeader from "../../../components/clipstore/user/broadcaster/profile/header";
import FilterContainer from "../../../components/clipstore/user/home/filter/container";
import ChipsContainer from "../../../components/clipstore/user/home/chips/container";
import HomeScreenEmptyContainer from "../../../components/clipstore/user/home/empty";
import HomeListContainer from "../../../components/clipstore/user/home/list";
import profile_util from "../../../util/clipstore/broadcaster/profile";
import {decodeEncryptedIdForBroadcaster, getEncryptedIdForBroadcaster} from "../../../util/broadcast_util";
import ProfileAboutPage from "../../../components/clipstore/user/broadcaster/profile/about";
import SubscribeToBroadcasterModal from "../../../components/modal/clipstore/user/subscribeToBroadcasterModal";
import constants from "../../../util/constants";
import ViewerProfileHeader from "../../../components/clipstore/user/profile/header";
import UserSubscriptionContainer from "../../user/subscriptions";
import UserProfileAboutContainer from "../../user/about";
import Following from "../../Following";
import {BROADCASTER, getUserDetail} from "../../../util/account_management";
import BroadcasterSubscribersContainer from "../../broadcaster/profile/subscribers";
import BroadcasterSubscriptionContainer from "../../broadcaster/profile/subscriptions";
import {Animated} from "react-animated-css";
import ReactImageVideoLightbox from "react-image-video-lightbox";
import utility from "../../../util/messaging/utility";
import {EditVideoModal} from "../../../components/modal/clipstore/broadcaster/EditVideoModal";
import {GalleryModal} from "../../../components/modal/clipstore/broadcaster/GalleryModal";
import {get as _get} from "lodash";

class HomeContainer extends Component {

    constructor(props) {
        super(props);

        this.loadingRef = React.createRef();

        this.state = {
            sort_by: 'all',
            only_subscribed_content: false,
            pricingType: 'all',
            contentType: 'all',
            sortBy: 'new',
            currentPage: 1,
            totalPages: 1,
            currentItems: 12,
            totalItems: 12,
            reset: false,
            hasMore: true,
            prices: pricing.set(0, 0, 0, 0),
            content: {},
            contentList: [],
            selectedPricing: {},
            isLoggedIn: false,
            walletBalance: "0.00",
            broadcasterID: -1,
            userID: -1,
            isPremiumContentModalOpen: false,
            isSubscriptionModalOpen: false,
            url: "",
            activeTab: "published_content",
            pageName: constants.HOME,
            tipMessage: null,

            viewerActiveTab: "purchased",
            isFollowing: false,
            selectedIndexOnGallery: 0,

            lightBoxData: [],
            isLighBoxVisible: false,

            isEditModalOpen: false,
            contentForPricing: null,

            isCreateGalleryModalOpen: false,
            galleryForEdit: null,
        }

        this.filterApplied = this.filterApplied.bind(this);
        this.setContentType = this.setContentType.bind(this);
        this.setSortBy = this.setSortBy.bind(this);
        this.resetFilters = this.resetFilters.bind(this);

        this.setPricingType = this.setPricingType.bind(this);
        this.setSortBy = this.setSortBy.bind(this);
        this.setContentType = this.setContentType.bind(this);
    }

    fetchMoneyblox = () => {
        getData(LOGIN)
            .then((data) => {
                this.setState({
                    isLoggedIn: !isEmpty(data)
                }, () => {
                    if (this.state.isLoggedIn) {
                        getMoneyBloxWalletUserSessionDetails(this.props)
                    }
                })
            })
    }

    componentDidMount() {
        const isPop = this.props.history.action === "POP";
        this.setState({
            pageName: home.pageName()
        }, () => {

            if (this.state.pageName === constants.HOME) {
                //Apply the default filter
                this.props.sortBroadcastBy("all");

                //init home
                this.fetchMoneyblox()

                //only call video or gallery details if it is a push
                !isPop && this.openModal(this.props.location);

                //show loading indicator
                this.loadingRef.current.continuousStart();

                //fetch home content
                api.getContentListAPI(this.props, this.state.pricingType, this.state.contentType, this.state.sortBy, this.state.currentPage, null, this.state.only_subscribed_content)
            } else if (this.state.pageName === constants.BROADCASTER_PROFILE) {
                const broadcasterID = profile_util.getBroadcasterId(this.props)

                if (broadcasterID !== -1) {
                    this.setState({
                        broadcasterID,
                        url: this.props.match.url
                    }, () => {
                        this.loadingRef.current.continuousStart();
                        api.getContentListAPI(this.props, this.state.pricingType, this.state.contentType, this.state.sortBy, this.state.currentPage, broadcasterID)
                    });
                } else {
                    const url_string = window.location.href
                    const url = new URL(url_string);
                    let broadcasterID = decodeEncryptedIdForBroadcaster(url.searchParams.get("broadcasterID"));

                    if (broadcasterID !== -1) {
                        this.setState({
                            broadcasterID,
                        }, () => {
                            this.loadingRef.current.continuousStart();
                            api.getContentListAPI(this.props, this.state.pricingType, this.state.contentType, this.state.sortBy, this.state.currentPage, broadcasterID)
                        });
                    }
                }
            } else if (this.state.pageName === constants.VIEWER_PROFILE) {

                const userID = profile_util.getUserId(this.props)

                if (userID !== -1) {
                    this.setState({
                        userID,
                    }, () => {
                        //someone is trying to access different user's profile
                    });
                } else {
                    //user is accessing their own profile
                    if (this.state.viewerActiveTab === "purchased") {
                        this.props.sortBroadcastBy("purchase");
                    }
                }
            }
        })

    }

    componentDidUpdate(prevProps) {

        if (this.props.history.action !== "POP") {
            const isChanges = this.props.location.pathname !== prevProps.location.pathname;

            if (isChanges) {
                this.openModal(this.props.location)
            }
        } else if (this.props.history.action === "POP" && this.props.history.location.pathname !== "/user/profile") {
            this.props.history.push(`/dashboard`);
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps) {

        if (nextProps.broadcaster_detail_management &&
            nextProps.broadcaster_detail_management.sortBroadcastBy &&
            this.state.sort_by !== nextProps.broadcaster_detail_management.sortBroadcastBy) {

            getData(LOGIN)
                .then((data) => {
                    if (!isEmpty(data)) {
                        this.setState({
                            reset: true,
                            currentPage: 1,
                            totalPages: 1,
                            currentItems: 12,
                            totalItems: 12,
                            sort_by: nextProps.broadcaster_detail_management.sortBroadcastBy,
                            only_subscribed_content: nextProps.broadcaster_detail_management.sortBroadcastBy === "subscriptions"
                        }, () => {
                            if (this.state.sort_by === "all" || this.state.sort_by === "subscriptions") {
                                this.loadingRef.current.continuousStart();
                                api.getContentListAPI(this.props, this.state.pricingType, this.state.contentType, this.state.sortBy, this.state.currentPage, null, this.state.only_subscribed_content)
                            } else {
                                this.loadingRef.current.continuousStart();
                                api.getHistoryAPI(this.props, this.state.sort_by, "new", this.state.currentPage)
                            }
                        });
                    }
                })

            // if (this.state.isLoggedIn) {
            //
            // } else {
            //     home.showLogin(this.props);
            // }

        }
        //this block invokes when user search for it
        if (nextProps.broadcaster_detail_management.hasOwnProperty("performSearch") && nextProps.broadcaster_detail_management.performSearch) {
            this.loadingRef.current.continuousStart();
            this.setState({
                reset: true,
                currentPage: 1,
                totalPages: 1,
                currentItems: 12,
                totalItems: 12,
            }, () => {
                api.getContentListAPI(this.props, this.state.pricingType, this.state.contentType, this.state.sortBy, this.state.currentPage, null, this.state.only_subscribed_content)
                this.props.setSearchForBroadcasterState(false);
            })
        }

        //this will be called for every pagination we perform
        if (nextProps.get_content_list && nextProps.get_content_list.payload !== this.props.get_content_list.payload) {

            if (nextProps.get_content_list.payload &&
                nextProps.get_content_list.payload.hasOwnProperty("data") &&
                nextProps.get_content_list.payload.data.hasOwnProperty("data")) {

                this.loadingRef.current.complete();

                let data = nextProps.get_content_list.payload.data;
                let contentList = data.data;

                if(this.state.pageName !== constants.BROADCASTER_PROFILE){
                    if (this.state.currentPage !== 1) {
                        if (contentList.length > 0) {
                            contentList = this.state.contentList.concat(nextProps.get_content_list.payload.data.data)
                        } else {
                            contentList = this.state.contentList;
                        }
                    }
                } else {
                    if (this.state.currentPage !== 1) {
                        if (contentList.length > 0) {
                            contentList = this.state.contentList.concat(nextProps.get_content_list.payload.data.data)
                        } else {
                            contentList = this.state.contentList;
                        }
                    }
                }


                //fast switching causes to show duplicates
                contentList = _.uniqBy(contentList, function (e) {
                    return e.id;
                });

                this.setState({
                    currentPage: parseInt(data.current_page),
                    hasMore: parseInt(data.current_page) <= parseInt(data.last_page),
                    totalPages: parseInt(data.last_page),
                    currentItems: parseInt(data.current_page) * data.data.length,
                    totalItems: parseInt(data.total),
                    contentList,
                    reset: false
                }, () => {
                    if (this.state.hasMore && this.state.currentPage < 3) {
                        this.loadNextPage();
                    }
                })
            }
        }

        tip_util.handleAPIResponse(nextProps, (message) => {
            this.setState({
                tipMessage: message
            })
        }, () => {

        });

        if (this.props.moneyblox.wallet_balance !== nextProps.moneyblox.wallet_balance) {
            this.setState({
                walletBalance: nextProps.moneyblox.wallet_balance
            })
        }

        //handle the API response for accessing the video details
        library.handleAPIResponse(nextProps, "get_video_details", () => {

            //reset the payload value as we have captured the event
            this.props.resetGetVideoDetailsById();
            this.loadingRef.current.complete();

        }, () => {
            //check if url is present and then take decision
            const payload = nextProps.get_video_details.hasOwnProperty("payload") &&
                nextProps.get_video_details.payload.hasOwnProperty("success") &&
                nextProps.get_video_details.payload.success.hasOwnProperty("data") &&
                nextProps.get_video_details.payload.success.data;


            if (payload && payload.hasOwnProperty("pricing")) {
                if (payload && payload.hasOwnProperty("url") && payload.url === "") {
                    const subscription = payload.pricing_type !== "exclusive" ? payload.pricing.subscription : 0
                    let prices = pricing.set(payload.pricing.ppm, payload.pricing.price, 0, subscription, "");
                    this.setState({
                        content: payload,
                        prices
                    }, () => {
                        this.setPremiumContentModalOpen(true)
                    })
                } else {
                    //we have the url let's go onto detail page
                    this.props.history.push(`/video/${payload.id}`, {
                        content: payload
                    });
                }
            }
        }, () => {
            //nothing to handle
            home.ageRestrictionForContent(nextProps,this.props,"get_video_details");
        }, true, false)

        //handle the API response for accessing the picture details
        library.handleAPIResponse(nextProps, "get_picture_details", () => {
            //reset the payload value as we have captured the event
            this.props.resetGetPictureDetailsById();
            this.loadingRef.current.complete();
        }, () => {
            //check if url is present and then take decision
            const payload = nextProps.get_picture_details.hasOwnProperty("payload") &&
                nextProps.get_picture_details.payload.hasOwnProperty("success") &&
                nextProps.get_picture_details.payload.success.hasOwnProperty("data") &&
                nextProps.get_picture_details.payload.success.data;

            this.setLightBoxData(utility.getLightBoxData([payload]))

        }, () => {
            //nothing to handle
            home.ageRestrictionForContent(nextProps,this.props,"get_picture_details");
        }, true, false)

        //handle the API response for accessing the video details
        library.handleAPIResponse(nextProps, "get_gallery_details", () => {
            //reset the payload value as we have captured the event
            this.props.resetGetGalleryDetailsById();
            this.loadingRef.current.complete();
        }, () => {
            //check if url is present
            const payload = nextProps.get_gallery_details.hasOwnProperty("payload") &&
                nextProps.get_gallery_details.payload.hasOwnProperty("success") &&
                nextProps.get_gallery_details.payload.success.hasOwnProperty("data") &&
                nextProps.get_gallery_details.payload.success.data;

            if (!this.state.isCreateGalleryModalOpen) {
                if (home.isVideo(this.state.content)) {
                    if (payload && payload.hasOwnProperty("pricing")) {
                        if (payload && payload.hasOwnProperty("videos") && Array.isArray(payload.videos) && payload.videos.length > 0 && payload.videos[0].url === "") {
                            const video = payload.videos[0];
                            const subscription = payload.pricing_type !== "exclusive" ? payload.pricing.subscription : 0
                            let prices = pricing.set(video.pricing.ppm, video.pricing.price, payload.pricing.price, subscription, "");
                            this.setState({
                                selectedIndexOnGallery: 0,
                                content: payload,
                                prices
                            }, () => {
                                this.setPremiumContentModalOpen(true)
                            })
                        } else {
                            //we have the url let's go onto detail page
                            this.props.history.push(`/gallery/${payload.id}`, {
                                content: payload
                            });
                        }
                    }
                } else {
                    this.setLightBoxData(utility.getLightBoxData(payload.pictures))
                }
            } else {
                this.setState({
                    galleryForEdit: payload
                }, () => {
                    this.props.setAddEditPricing(this.state.galleryForEdit)
                })
            }

        }, () => {
            //nothing to handle
            home.ageRestrictionForContent(nextProps,this.props,"get_gallery_details");
        }, true, false)

        //handle the API response for purchase content response
        library.handleAPIResponse(nextProps, "purchase_content", () => {
            //reset the payload value as we have captured the event
            this.loadingRef.current.complete();
            this.props.resetPurchaseContent();

        }, () => {
            //check if url is present
            //we have the url let's go onto detail page
            const payload = nextProps.purchase_content.hasOwnProperty("payload") &&
                nextProps.purchase_content.payload.hasOwnProperty("success") &&
                nextProps.purchase_content.payload.success.hasOwnProperty("data") &&
                nextProps.purchase_content.payload.success.data;


            let content = this.state.content;
            let pricing = this.state.selectedPricing;


            if (content.hasOwnProperty("videos")) {
                this.props.history.push(`/gallery/${this.state.content.id}`);
            } else {
                this.props.history.push(`/video/${this.state.content.id}`, {
                    content: payload,
                    pricing
                });
            }

        }, () => {
            //nothing to handle
        })

        //handle the API response for subscription
        library.handleAPIResponse(nextProps, "subscribe_to_broadcaster", () => {
            //reset the payload value as we have captured the event
            this.loadingRef.current.complete();
            this.props.resetSubscribeToBroadcaster();

        }, () => {
            //check if url is present
            //we have the url let's go onto detail page
            const payload = nextProps.subscribe_to_broadcaster.hasOwnProperty("payload") &&
                nextProps.subscribe_to_broadcaster.payload.hasOwnProperty("success") &&
                nextProps.subscribe_to_broadcaster.payload.success.hasOwnProperty("data") &&
                nextProps.subscribe_to_broadcaster.payload.success.data;


            let content = this.state.content;
            let pricing = this.state.selectedPricing;

            if (content.hasOwnProperty("videos")) {
                this.props.history.push(`/gallery/${this.state.content.id}`);
            } else if (this.state.content && this.state.content.hasOwnProperty("id")) {
                this.props.history.push(`/video/${this.state.content.id}`, {
                    content: payload,
                    pricing
                });
            } else if (this.state.isSubscriptionModalOpen) {
                window.location.reload();
            }

        }, () => {
            //nothing to handle
        })

        //handle the API response for subscription
        if (nextProps.following && nextProps.following.follow_unfollow_data !== this.props.following.follow_unfollow_data &&
            nextProps.following.follow_unfollow_data.hasOwnProperty("success") &&
            nextProps.following.follow_unfollow_data.success.hasOwnProperty("message")) {
            vuepayAlert("success", nextProps.following.follow_unfollow_data.success.message);
            this.reloadBroadcasterProfilePage();
        }

        library.handleAPIResponse(nextProps, "cancel_subscription", () => {

        }, () => {
            this.reloadBroadcasterProfilePage();
            this.props.resetCancelSubscription();
        }, () => {

        });

        if (nextProps.delete_videos && nextProps.delete_videos.payload != null) {

            //reset the payload value as we have captured the event
            this.props.resetDeleteVideos();

            if (nextProps.delete_videos.payload.hasOwnProperty("success") && nextProps.delete_videos.payload.success.hasOwnProperty("message")) {
                //refresh the library
                vuepayAlert("success", nextProps.delete_videos.payload.success.message)
            } else if (nextProps.delete_videos.hasOwnProperty("isError") && nextProps.delete_videos.isError) {
                if (nextProps.delete_videos.payload.hasOwnProperty("message")) {
                    vuepayAlert("error", nextProps.delete_videos.payload.message)
                }
            }
        }

        //handle the API response for deleting the video
        library_api.handleAPIResponse(nextProps, "delete_gallery", () => {
            //reset the payload value as we have captured the event
            this.props.resetDeleteGallery();
        }, () => {
            //this.props.history.push("/broadcaster/my-library")
            //this.getMyGallery()
        }, () => {
            //nothing to handle
        })
    }

    openModal = (location) => {
        let id = -1, type = "";

        if (location.state && location.state.hasOwnProperty("content") && location.state.content !== null) {
            let content = location.state.content;
            id = content.id;
            type = content.type;
        } else {
            if (location.hasOwnProperty("pathname") && (location.pathname.indexOf("video") > 0 || location.pathname.indexOf("gallery") > 0)) {
                type = location.pathname.indexOf("video") > 0 ? "video" : "gallery";
                let locationArray = location.pathname.split("/");
                id = locationArray[locationArray.length - 1];
                if (id.length < 30) {
                    id = -1
                }
            } else if (this.state.pageName === constants.BROADCASTER_PROFILE) {
                let locationArray = location.pathname.split("/");
                id = decodeEncryptedIdForBroadcaster(locationArray[locationArray.length - 1]);
                if (id !== -1 && this.state.broadcasterID !== id) {
                    const broadcasterID = profile_util.getBroadcasterId(this.props)
                    this.setState({
                        broadcasterID,
                        currentPage: 1,
                        totalPages: 1,
                        currentItems: 12,
                        totalItems: 12,
                        url: this.props.match.url
                    }, () => {
                        this.loadingRef.current.continuousStart();
                        api.getContentListAPI(this.props, this.state.pricingType, this.state.contentType, this.state.sortBy, this.state.currentPage, broadcasterID)
                    });
                }
            }
        }

        if (id !== -1) {
            if (type === "video") {
                api.getVideoDetailsByIdAPI(this.props, id);
                this.loadingRef.current.continuousStart()
            } else if (type === "gallery") {
                api.getGalleryDetailsByIdAPI(this.props, id)
                this.loadingRef.current.continuousStart()
            }
        }
    }

    setLightBoxData = (data) => {

        this.setState({
            lightBoxData: data
        })
    }

    showLightBox = () => {
        this.setState({
            isLighBoxVisible: true
        })
    }

    hideLightBox = () => {
        this.setState({
            lightBoxData: [],
            isLighBoxVisible: false
        })
    }

    reloadBroadcasterProfilePage = () => {
        this.setState({
            pricingType: "all",
            contentType: "all",
            sortBy: "new",
            reset: true,
            currentPage: 1,
            totalPages: 1,
            currentItems: 12,
            totalItems: 12,
        }, () => {
            //refresh the page
            this.loadingRef.current.continuousStart()
            api.getContentListAPI(this.props, this.state.pricingType, this.state.contentType, this.state.sortBy, this.state.currentPage, this.state.broadcasterID)
        })
    }

    filterApplied = (pricingType, contentType, sortBy) => {
        this.setState({
            pricingType: pricingType === null ? this.state.pricingType : pricingType,
            contentType: contentType === null ? this.state.contentType : contentType,
            sortBy: sortBy === null ? this.state.sortBy : sortBy,
            reset: true,
            currentPage: 1,
            totalPages: 1,
            currentItems: 12,
            totalItems: 12,
        }, () => {
            //refresh the page
            this.loadingRef.current.continuousStart()
            api.getContentListAPI(this.props, this.state.pricingType, this.state.contentType, this.state.sortBy, this.state.currentPage, null, this.state.only_subscribed_content)
        })
    }

    setPricingType(pricingType) {
        this.filterApplied(home.getModifiedFilterValue(this.state.pricingType, pricingType), null, null)
    }

    setContentType(contentType) {
        this.filterApplied(null, home.getModifiedFilterValue(this.state.contentType, contentType), null)
    }

    setSortBy(sortBy) {
        this.filterApplied(null, null, sortBy)
    }

    resetFilters() {
        this.filterApplied("all", "all", "new")
    }


    setPremiumContentModalOpen = (isPremiumContentModalOpen) => {
        this.setState({
            isPremiumContentModalOpen: isPremiumContentModalOpen
        })
    }

    setSubscriptionModalOpen = (isSubscriptionModalOpen) => {
        this.setState({
            isSubscriptionModalOpen: isSubscriptionModalOpen
        })
    }

    toggle = (tab) => {
        if (this.state.activeTab !== tab) {
            this.setState({
                activeTab: tab,
            });
        }
    };

    toggleViewerTabs = (tab) => {
        if (this.state.viewerActiveTab !== tab) {
            this.setState({
                viewerActiveTab: tab,
            }, () => {
                if (this.state.viewerActiveTab === "purchased") {
                    this.props.sortBroadcastBy("purchase");
                } else if (this.state.viewerActiveTab === "subscribed") {
                    this.props.sortBroadcastBy("subscriptions");
                }
            });
        }
    };


    updateWalletBalance = () => {
        getMoneyBloxCurrentWalletBalance((wallet_balance) => {
            this.setState({
                wallet_balance: wallet_balance,
            });

            this.props.setWalletBalance(wallet_balance);
        });

        //this updates the redux state
        getMoneyBloxWalletUserSessionDetails(this.props);
    };

    showRequestTipModal = () => {
        getData(LOGIN).then((data) => {
            if (!isEmpty(data)) {
                this.props.showTipModal();
                this.updateWalletBalance();
            } else {
                this.props.history.push({
                    pathname: "/login",
                    state: {basePath: this.props.history.location.pathname},
                });
            }
        });
    };

    tipRequest = (tipAmount, screen) => {

        let broadcaster_id = this.state.broadcasterID
        let broadcast_id = null;

        tip_util.tipRequest(this.props, tipAmount, screen, broadcaster_id, broadcast_id, () => {
            this.updateWalletBalance();
        })

    };


    loadNextPage = () => {
        let currentPage = this.state.currentPage;
        currentPage = currentPage + 1;

        this.setState({
            currentPage
        }, () => {
            this.loadingRef.current.continuousStart();
            if (this.state.pageName === constants.HOME) {
                api.getContentListAPI(this.props, this.state.pricingType, this.state.contentType, this.state.sortBy, this.state.currentPage, null, this.state.only_subscribed_content)
            } else if (this.state.pageName === constants.BROADCASTER_PROFILE) {
                api.getContentListAPI(this.props, this.state.pricingType, this.state.contentType, this.state.sortBy, this.state.currentPage, this.state.broadcasterID)
            }
        })
    }

    setVideoPriceForSelectedGallery = (payload,index) => {
        const video = payload.videos[index];
        const subscription = payload.pricing_type !== "exclusive" ? payload.pricing.subscription : 0
        let prices = pricing.set(video.pricing.ppm, video.pricing.price, payload.pricing.price, subscription, "");
        this.setState({
            selectedIndexOnGallery: index,
            prices
        })
    }

    tabBarContent = (activeTab) => {
        const isContentList = (this.state.sort_by === "all" || this.state.sort_by === "subscriptions");
        const isFilterApplied = (this.state.pricingType.toLowerCase() !== "all" || this.state.contentType.toLowerCase() !== "all" || this.state.sortBy.toLowerCase() !== "new");

        switch (activeTab) {
            case "published_content":
            case "purchased":
            case "subscribed":
                return (
                    <div>
                        <FilterContainer
                            isContentList={isContentList}
                            pricingType={this.state.pricingType}
                            setPricingType={this.setPricingType}
                            contentType={this.state.contentType}
                            setContentType={this.setContentType}
                            sortBy={this.state.sortBy}
                            setSortBy={this.setSortBy}
                        />

                        <ChipsContainer
                            isContentList={isContentList}
                            isFilterApplied={isFilterApplied}
                            pricingType={this.state.pricingType}
                            setPricingType={this.setPricingType}
                            contentType={this.state.contentType}
                            setContentType={this.setContentType}
                            sortBy={this.state.sortBy}
                            setSortBy={this.setSortBy}
                            resetFilters={this.resetFilters}
                        />

                        <HomeScreenEmptyContainer
                            contentList={this.state.contentList}
                            get_content_list={this.props.get_content_list}
                        />

                        <HomeListContainer
                            pageName={this.state.pageName}
                            isBroadcastersOwnPage={this.isBroadcastersOwnPage()}
                            editVideo={this.editVideo}
                            deleteVideo={this.deleteVideo}
                            editGallery={this.editGallery}
                            deleteGallery={this.deleteGallery}

                            totalItems={this.state.totalItems}
                            currentPage={this.state.currentPage}
                            loadNextPage={this.loadNextPage}
                            hasMore={this.state.hasMore}
                            contentList={this.state.contentList}
                            history={this.props.history}
                            openVideoPage={(content) => {
                                this.setState({
                                    content
                                }, () => {
                                    if (this.state.pageName === constants.HOME) {
                                        this.props.history.replace(`/dashboard/video/${content.id}`, {
                                            content
                                        });
                                    } else if (this.state.pageName === constants.BROADCASTER_PROFILE) {
                                        this.props.history.push(`/profile/video/${content.id}?broadcasterID=${getEncryptedIdForBroadcaster(this.state.broadcasterID)}`, {
                                            content
                                        });
                                    }

                                })
                            }}
                            openGalleryPage={(content,extra) => {
                                this.setState({
                                    content
                                }, () => {
                                    if (home.isVideo(this.state.content)) {
                                        if (this.state.pageName === constants.HOME) {
                                            this.props.history.replace(`/dashboard/gallery/${content.id}`, {
                                                content
                                            });
                                        } else if (this.state.pageName === constants.BROADCASTER_PROFILE) {
                                            this.props.history.push(`/profile/gallery/${content.id}?broadcasterID=${getEncryptedIdForBroadcaster(this.state.broadcasterID)}`, {
                                                content
                                            });
                                        }
                                    } else {
                                        if(extra){
                                            this.props.history.replace(`/gallery/${content.id}`, {
                                                content
                                            });
                                        }else{
                                            api.getGalleryDetailsByIdAPI(this.props, content.id);
                                            this.showLightBox();
                                        }
                                    }
                                })
                            }}
                            openPicturePage={(content,extra) => {
                                if(extra){
                                    this.props.history.replace(`/picture/${content.id}`, {
                                        content
                                    });
                                }else{
                                    this.setState({
                                        content
                                    }, () => {
                                        api.getPictureDetailsByIdAPI(this.props, content.id);
                                        this.showLightBox();
                                    })
                                }
                            }}
                            clickedOnLike={(content) => {
                                console.log("clickedOnLike >> content",content)
                            }}
                        />
                    </div>
                )
            default:
                return (<div/>)
        }
    }

    isBroadcastersOwnPage = () => {
        const broadcaster_id = getUserDetail(this.props, BROADCASTER, "id");
        return parseInt(this.state.broadcasterID) === parseInt(broadcaster_id);
    }

    isBroadcasterProfileVisible = ()=>{
        return (
            this.state.pageName === constants.BROADCASTER_PROFILE &&
            this.state.contentList &&
            this.props.get_content_list.payload !== null
        )
    }

    setEditVideoModal = (isEditModalOpen) => {
        this.setState({
            isEditModalOpen
        })
    }

    setCreateGalleryModal = (isCreateGalleryModalOpen) => {
        this.setState({
            isCreateGalleryModalOpen,
            galleryForEdit: null
        })
    }

    editVideo = (id)=> {
        const result = this.state.contentList.filter(content => content.id === id);
        if (Array.isArray(result) && result.length > 0) {
            this.setState({
                contentForPricing: result[0],
                isEditModalOpen: true
            }, () => {
                this.props.setAddEditPricing(result[0])
            });
        }
    }

    deleteVideo = (id) => {
        let idArray = library_api.getVideoOrPictureArray(this.state.contentList, id);
        library_api.onDelete(this.props, idArray["videoIdArray"], idArray["pictureIdArray"])
    }

    deleteGallery = (id) => {
        library_api.deleteGalleryAPI(this.props, id)
    }

    editGallery = (id) => {
        this.setCreateGalleryModal(true);
        //const result = this.state.contentList.filter(content => content.id === id);
        api.getGalleryDetailsByIdAPI(this.props, id);
    }

    render() {

        let payload = this.props.get_content_list.payload;

        return (
            <main role="main" className="container-fluid">

                <GalleryModal
                    isOpen={this.state.isCreateGalleryModalOpen && this.state.galleryForEdit}
                    history={this.props.history}
                    toggle={(key) => {
                        this.setCreateGalleryModal(false)

                        if (key === "refresh") {
                        }
                    }}
                    editMode={true}
                    title={"Edit Gallery"}
                />

                {
                    this.state.isEditModalOpen &&
                    <EditVideoModal
                        isOpen={this.state.isEditModalOpen}
                        toggle={(key) => {
                            this.setEditVideoModal(false);

                            if (key === "refresh") {
                                //this.getMyLibrary(true);
                            }
                        }}
                        history={this.props.history}
                    />
                }

                <LoadingBar color='#f11946' ref={this.loadingRef}/>

                {
                    this.state.isLighBoxVisible &&
                    <div className="vuepay-react-lightbox" style={{marginLeft: -15, marginRight: -15}}>
                        <ReactImageVideoLightbox
                            data={this.state.lightBoxData}
                            startIndex={0}
                            showResourceCount={true}
                            onCloseCallback={() => {
                                this.hideLightBox()
                            }}
                        />
                    </div>
                }

                {
                    this.state.pageName === constants.BROADCASTER_PROFILE &&
                    this.state.contentList &&
                    Array.isArray(this.state.contentList) &&
                    this.state.contentList.length > 0 &&
                    this.state.contentList[0].hasOwnProperty("subscription") &&
                    this.state.contentList[0].subscription.hasOwnProperty("amount") &&
                    <SubscribeToBroadcasterModal
                        {...this.props}
                        isOpen={this.state.isSubscriptionModalOpen}
                        toggle={(key) => {
                            this.setSubscriptionModalOpen(false)
                        }}
                        broadcaster={this.state.contentList[0].broadcaster}
                        subscribeAmount={this.state.contentList[0].subscription.amount}
                    />
                }

                {
                    this.state.content &&
                    this.state.content.hasOwnProperty("id") &&
                    <PremiumContentModal
                        isOpen={this.state.isPremiumContentModalOpen}
                        toggle={(key, value) => {
                            this.setPremiumContentModalOpen(false)
                            if (key === "open_profile") {
                                this.props.history.push(`/profile/${value}`);
                            } else if (this.state.pageName === constants.HOME) {
                                this.props.history.push(`/dashboard`);
                            }
                        }
                        }
                        setPaymentChoice={(value) => {
                            const payload = this.state.content;
                            pricing.setPaymentChoice(value, payload, (prices) => {
                                this.setState({
                                    prices
                                })
                            })
                        }}
                        prices={this.state.prices}
                        content={this.state.content}


                        buy={(price) => {
                            this.setState({
                                selectedPricing: price[0]
                            })
                            pricing.purchaseContent(this.props, this.state.content, price[0])
                        }}
                        purchase_content={this.props.purchase_content}

                        history={this.props.history}
                        location={this.props.location}

                        setWalletBalance={this.props.setWalletBalance}
                        showMoneyBloxModal={this.props.showMoneyBloxModal}
                        selectedIndexOnGallery={this.state.selectedIndexOnGallery}
                        setVideoPriceForSelectedGallery={this.setVideoPriceForSelectedGallery}
                    />
                }

                <div>
                    <Row className={"broadcast-container-parent"} id="homeContainerScrollableDiv">
                        <Col md="12" className="home-container">

                            <Animated animationIn="fadeIn" animationOut="fadeOut" animationInDuration={1000} animationOutDuration={1000} isVisible={this.isBroadcasterProfileVisible()}>
                                {

                                    <BroadcasterProfileHeader
                                        {...this.props}
                                        isLoggedIn={this.state.isLoggedIn}
                                        pageName={this.state.pageName}
                                        contentList={this.state.contentList}
                                        activeTab={this.state.activeTab}
                                        payload={payload}
                                        toggle={this.toggle}
                                        filterApplied={this.filterApplied}
                                        showLogin={() => {
                                            home.showLogin(this.props)
                                        }}
                                        setSubscriptionModalOpen={this.setSubscriptionModalOpen}
                                        showTipResponseModalFlag={this.props.showTipResponseModalFlag}
                                        showRequestTipModal={this.showRequestTipModal}
                                        wallet_balance={this.state.wallet_balance}
                                        tipRequest={this.tipRequest}
                                        tipValue={this.state.tipValue}
                                        lowBalanceAlert={this.state.lowBalanceAlert}
                                        tipMessage={this.state.tipMessage}
                                        broadcasterID={this.state.broadcasterID}
                                        isBroadcastersOwnPage={this.isBroadcastersOwnPage()}
                                        isFollowing={this.state.isFollowing}
                                    />
                                }
                            </Animated>

                            {
                                this.state.pageName === constants.VIEWER_PROFILE &&
                                <ViewerProfileHeader
                                    {...this.props}
                                    isLoggedIn={this.state.isLoggedIn}
                                    pageName={this.state.pageName}
                                    contentList={this.state.contentList}
                                    activeTab={this.state.viewerActiveTab}
                                    payload={payload}
                                    toggle={this.toggleViewerTabs}
                                    showLogin={() => {
                                        home.showLogin(this.props)
                                    }}
                                />
                            }

                            {
                                (this.state.pageName === constants.HOME || this.state.pageName === constants.BROADCASTER_PROFILE) &&
                                <TabContent activeTab={this.state.activeTab}>

                                    <TabPane tabId="published_content" className="bg-transparent">
                                        {this.tabBarContent("published_content")}
                                    </TabPane>

                                    <TabPane tabId="followers" className="bg-transparent">
                                        Followers
                                    </TabPane>

                                    {
                                        this.state.pageName === constants.BROADCASTER_PROFILE &&
                                        <TabPane tabId="about">
                                            {
                                                this.state.contentList &&
                                                payload !== null &&
                                                <ProfileAboutPage contentList={this.state.contentList}
                                                                  payload={payload}/>
                                            }
                                        </TabPane>
                                    }

                                    {
                                        this.state.pageName === constants.BROADCASTER_PROFILE &&
                                        <TabPane tabId="subscriptions">
                                            <BroadcasterSubscriptionContainer {...this.props}/>
                                        </TabPane>
                                    }

                                    {
                                        this.state.pageName === constants.BROADCASTER_PROFILE &&
                                        <TabPane tabId="subscribers">
                                            <BroadcasterSubscribersContainer {...this.props}/>
                                        </TabPane>
                                    }

                                </TabContent>
                            }

                            {
                                this.state.pageName === constants.VIEWER_PROFILE &&
                                <TabContent activeTab={this.state.viewerActiveTab}>

                                    <TabPane tabId="purchased" className="bg-transparent">
                                        {this.tabBarContent("purchased")}
                                    </TabPane>

                                    <TabPane tabId="subscribed" className="bg-transparent">
                                        {this.tabBarContent("subscribed")}
                                    </TabPane>

                                    <TabPane tabId="subscriptions">
                                        <UserSubscriptionContainer {...this.props}/>
                                    </TabPane>

                                    <TabPane tabId="following">
                                        <Following
                                            children={true}
                                            match={this.props.match}
                                            history={this.props.history}
                                            location={this.props.location}
                                        />
                                    </TabPane>

                                    <TabPane tabId="viewer_about">
                                        <UserProfileAboutContainer {...this.props}/>
                                    </TabPane>

                                </TabContent>
                            }

                        </Col>
                    </Row>
                </div>
            </main>
        );
    }
}


function mapStateToProps(state, ownParams) {
    return {
        flag: state.flag,
        device: state.device.payload,
        delete_videos: state.clipstore_broadcaster_delete_videos,
        delete_gallery: state.clipstore_broadcaster_reducer_delete_gallery,
        get_content_list: state.get_content_list,
        get_video_details: state.get_video_details,
        get_picture_details: state.get_picture_details,
        get_gallery_details: state.get_gallery_details,
        purchase_content: state.purchase_content,
        subscribe_to_broadcaster: state.subscribe_to_broadcaster,
        showTipModalFlag: state.flag.showTipModalFlag,
        showTipResponseModalFlag: state.flag.showTipResponseModalFlag,
        moneyblox: state.moneyblox,
        broadcaster_detail_management: state.broadcaster_detail_management,
        tip: state.tip,
        following: state.following,
        account_management: state.account_management,
        cancel_subscription: state.cancel_subscription,
    };
}

export default connect(mapStateToProps, actions)(HomeContainer);
